// Search Results App
import * as Vue from 'vue';
import SearchResults from './containers/search-results.vue';

const app = Vue.createApp(SearchResults);
app.mount('#search-results-app');